<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5 2H14.3334C15.0698 2 15.6667 2.59695 15.6667 3.33333V14.6667C15.6667 15.403 15.0698 16 14.3334 16H1.66671C0.930328 16 0.333374 15.403 0.333374 14.6667V3.33333C0.333374 2.59695 0.930328 2 1.66671 2H2.66671C2.8508 2 3.00004 2.14924 3.00004 2.33333V3.83333C3.00004 4.10948 3.2239 4.33333 3.50004 4.33333C3.77618 4.33333 4.00004 4.10948 4.00004 3.83333V0.666667C4.00004 0.298477 4.29852 0 4.66671 0C5.0349 0 5.33337 0.298477 5.33337 0.666667V1.834C5.33374 1.92579 5.40825 2 5.50004 2H9.66671C9.8508 2 10 2.14924 10 2.33333V3.83333C10 4.10948 10.2239 4.33333 10.5 4.33333C10.7762 4.33333 11 4.10948 11 3.83333V0.666667C11 0.298477 11.2985 0 11.6667 0C12.0349 0 12.3334 0.298477 12.3334 0.666667V1.83333C12.3334 1.92538 12.408 2 12.5 2ZM2.00004 14.6667H14C14.1841 14.6667 14.3334 14.5174 14.3334 14.3333V6.33333C14.3334 6.14924 14.1841 6 14 6H2.00004C1.81595 6 1.66671 6.14924 1.66671 6.33333V14.3333C1.66671 14.5174 1.81595 14.6667 2.00004 14.6667Z" fill="#6B7E99"/>
</svg>

</template>

<script>
export default {
name:"CalendarFilter"
}
</script>

<style>

</style>